import { render, staticRenderFns } from "./view-or-select-serials.vue?vue&type=template&id=9a430270&"
import script from "./view-or-select-serials.vue?vue&type=script&lang=ts&"
export * from "./view-or-select-serials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports